var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "f442a5c8664c64cbaf9ab267aa183b6b.png",
    width: 606,
    height: 878
});